import { observer } from "mobx-react-lite";

import type { ISubPanel } from ".";
import { getSubEditorTitleProps } from "@/styles/subEditor";
import SubPanelWithScrollBar from "./WithScrollBar";

function SubEditorPanel({ children, ...others }: ISubPanel) {
  const titleProps = others.panelTitle ? getSubEditorTitleProps() : {};
  return (
    <SubPanelWithScrollBar {...titleProps} {...others}>
      {children}
    </SubPanelWithScrollBar>
  );
}

export default observer(SubEditorPanel);
